const newSealType = {
  snackbar: "Ihr Update ist fertig",
  name: "Dichtungstyp",
  save: "speichern",
  cancel: "Stornieren",
  area: "Dichtungstyp",
  formTitle: "Neuer Dichtungstyp",
  confirm: "Möchten Sie diesen Artikel wirklich löschen?",
  close: "Schließen",
  delete: "Löschen"
};
export default newSealType;
